











import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import {executeQuery} from "@/data/repos/query"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {consoleUrl} from "@/data/sources/complianceLinks"

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit("config-update", config())
    const chartDSTemplate = reactive({categories: [], dataset: []})

    async function dataplotClickCallback(label: string, val: any, data: any) {
      if (!data) {
        const locationId = props.config && props.config.params.locationId
        console.debug("locationId: ", locationId)
        const url = consoleUrl(locationId.value)
        window.open(url, "_blank")
      }
    }

    return {dataFetcher, getChartDataConfig, configChangeCallback, dataplotClickCallback, chartDSTemplate}
  },
})

async function dataFetcher(params: any): Promise<{ Label: string, Value: number }[] | null> {
  if (!parseInt(params.locationId.value)) {
    return null
  }
  // [{"Label":"Compliant","Value":35},{"Label":"NonCompliant","Value":227},{"Label":"TotalBuildings","Value":307}]
  return executeQuery("idr", "compliance.overallBuildingCompliance", {
    locationId: parseInt(params.locationId.value),
  }, convert)
}

function config(): WidgetDefinition {
  return {
    ...WConfTpl.StackedBar2D(),
    widget: "ComplianceOverallBuildingCompliance",
    title: "Overall building compliance",
    w: 2, // override base template
    h: 1, // same here
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

function getChartDataConfig() {
  return reactive({
    ...ChartDataTemplate(),
    paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
    caption: "Compliance",
    theme: 'micad',
    // baseFont: "Arial",
    // baseFontSize: "11",
    // baseFontColor: "#0066cc",
    // legendBgColor: '#ffffff',
    // legendCaption: 'Legend',
    // legendCaptionBold: "1",
    // legendCaptionFont: 'Open Sans',
    // legendCaptionFontSize: "9",
    legendCaptionAlignment: 'left',
    legendBorderAlpha: "0",
    legendShadow: "0",
    stack100Percent: '1',
    canvasBorderThickness: '0',
    animation: "1",
    //subCaption: "",
    //showPercentValues: '1',
    //showPercentInToolTip: '1',
    //usePlotGradientColor: '0',
  })
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
}

function convert(data: { Label: string, Value: number }[]): any {
  const valueMap = new Map<string, number>()
  for (const item of data) {
    valueMap.set(item.Label, item.Value)
  }
  const compliantValue = valueMap.get('Compliant') || 0
  const nonCompliantValue = valueMap.get('NonCompliant') || 0
  return {
    categories: [
      {
        category: [{label: ''}],
      },
    ],
    dataset: [
      {
        seriesName: "Compliant",
        color: "#6baa01",
        data: [{value: compliantValue}],
      },
      {
        seriesName: "Non Compliant",
        color: "#DC143C",
        data: [{value: nonCompliantValue}],
      },
    ],
  }
}

